import React from 'react'
import { Container, Row, Col } from 'reactstrap'

const NoMatch = () => (
  <div>
    <Container>
      <Row>
        <Col>
          <h1>404</h1>
          <p>Page not found.</p>
        </Col>
      </Row>
    </Container>
  </div>
)

export default NoMatch



// WEBPACK FOOTER //
// ./src/containers/nomatch/index.jsx